<template>
  <div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#F2F3F5' }"
      size="small"
    >
      <el-table-column type="index" label="序号" />

      <el-table-column
        v-for="(item, i) in columns"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
      >
        <!-- 这里的 v-slot 改成具名插槽 -->
        <template v-slot="scope">
          <slot
            :name="item.prop"
            :row="scope.row"
            :item="item"
            :columnIndex="i"
          >
            <span>{{ scope.row[item.prop] || '--' }}</span>
          </slot>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      :page-sizes="[10, 20, 30, 50, 100]"
      :current-page="pagination.page"
      :page-size="pagination.size"
      :total="pagination.total"
      layout="total, prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 10,
        total: 0,
      }),
    },
  },
  methods: {
    // 页码改变时的处理
    handleSizeChange(val) {
      this.$emit("change", { ...this.pagination, size: val });
    },
    handleCurrentChange(val) {
      this.$emit("change", { ...this.pagination, page: val });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>
